import { CREATE_NOTE, DELETE_NOTE, FETCH_NOTE_PER_ENTITY, SAVE_NOTE } from "./ActionTypes";

const initialState: any = {
    unsaved: {},
    saved: {}
};

export default function noteReducer(state = initialState, action: any) {
    const { payload }  = action;
    switch (action.type) {
        case FETCH_NOTE_PER_ENTITY.SUCCESS:
        case CREATE_NOTE.SUCCESS:
        case SAVE_NOTE.SUCCESS:
        case DELETE_NOTE.SUCCESS: {
            const { data } = payload;

            if (data?.length === 0) {
                return {
                    ...state,
                    saved: {}
                }
            }
            
            return {
                ...state,
                saved: {
                    ...state.saved,
                    ...data
                }
            }
        }
        
        case FETCH_NOTE_PER_ENTITY.FAILURE:
        default:
            return state;
    }
}